import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon'

/**
 * Expand/collapse triangle for the content trees and collapsible menu sections.
 *
 * The triangle's bounding box is centred in the viewBox, so rotating the icon
 * reads as a spin about its own centre. A text glyph (▶) cannot do this: it is
 * painted inside a line box whose ink is offset by the font's side bearings and
 * baseline metrics, so rotating it looks like it pivots on the triangle's tip.
 *
 * Sized by font-size (`fontSize="inherit"`), so the parent controls the box.
 */
export function TreeChevronIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 10 10" fontSize="inherit" {...props}>
      <path d="M2.5 1.5 7.5 5 2.5 8.5Z" />
    </SvgIcon>
  )
}
